import { PLACEHOLDER_ACTIONS_DETAILS } from '@/constants/placeholders'
import type { TransactionsContext } from '@/queries/transactionsContext.query'
import type { StepData } from '@/types/transactionsContext'

interface Props {
  actions: TransactionsContext | undefined
  actionName: StepData['name']
}

export function getTransactionStepData({ actions, actionName }: Props): StepData | undefined {
  return (actions ?? PLACEHOLDER_ACTIONS_DETAILS).allSteps.find((action: any) => action.name === actionName)
}
